import React, { useEffect, useState } from 'react';

// Metalogix hexagon logo — 12 stroked paths (viewBox 76.95 x 70.8)
const LOGO_PATHS = [
  'M37.46,34.87l-4.67,2.52c-.65,.33-1.06,1-1.07,1.73l-.25,19.36-3.94,1.89c-.95,.54-2.1,.54-3.05,0l-13.74-7.86c-1.05-.6-1.68-1.75-1.65-2.99l.45-19.44c.03-1.04,.2-1.9,1.1-2.41l9.64-5.64c.63-.36,1.72-.27,2.36,.07,3.16,1.72,12.61,6.9,13.75,8.05,1.37,1.39,1.08,4.72,1.08,4.72h-.01Z',
  'M26,61.03c-.57,0-1.14-.15-1.66-.45l-13.74-7.86c-1.13-.64-1.81-1.88-1.78-3.22l.45-19.44c.03-1.02,.19-2.04,1.23-2.63l9.64-5.64c.76-.43,1.95-.3,2.62,.07,3.77,2.05,12.67,6.93,13.81,8.1,1.44,1.45,1.17,4.78,1.16,4.92v.14l-4.81,2.58c-.57,.29-.93,.87-.94,1.51l-.25,19.52-4.09,1.96c-.51,.29-1.07,.43-1.63,.43h0Zm-4.7-38.97c-.33,0-.66,.06-.9,.2l-9.64,5.64c-.77,.44-.94,1.16-.97,2.19l-.45,19.43c-.02,1.16,.56,2.21,1.52,2.76l13.74,7.87c.87,.5,1.91,.5,2.79,0l3.82-1.83,.25-19.2c.01-.83,.48-1.58,1.21-1.96l4.54-2.45c.03-.63,.1-3.25-1.02-4.38-.89-.91-7.66-4.73-13.69-8.01-.31-.17-.77-.27-1.21-.27h0Z',
  'M72.15,10.01v13.57l-5.73-3.05v-3.69c-.01-.81-.43-1.56-1.11-1.98L48.04,4.95,55.45,.3l16.69,9.71h.01Z',
  'M72.41,24.01l-6.25-3.33v-3.85c-.01-.72-.38-1.38-.99-1.76L47.54,4.96,55.45,0l16.96,9.86v14.15Zm-5.73-3.64l5.22,2.78V10.16L55.46,.6l-6.91,4.33,16.88,9.69c.77,.47,1.23,1.3,1.23,2.2v3.54h.02Z',
  'M62.13,60.95c-.04,.93-.54,1.77-1.33,2.24-2.4,1.4-7.66,4.47-11.06,6.46-1.84,1.07-4.07,1.17-6,.26l-8.24-4.74c-.82-.47-.82-1.46-.78-2.41v-5.08l10.91,6.58c.64,.39,1.44,.39,2.09,0,3.42-2.07,14.33-8.38,14.33-8.38l.09,5.08h-.01Z',
  'M46.49,70.79c-.98,0-1.95-.21-2.86-.64l-8.26-4.75c-1-.58-.95-1.82-.91-2.65v-5.53l11.3,6.82c.56,.34,1.26,.34,1.82,0,3.38-2.05,14.22-8.32,14.33-8.38l.38-.22,.1,5.53h0c-.05,1.03-.59,1.94-1.46,2.46-2.4,1.4-7.66,4.47-11.06,6.46-1.04,.61-2.21,.91-3.38,.91h0Zm-11.52-12.67v4.63c-.04,.97-.02,1.8,.65,2.19l8.24,4.74c1.82,.86,3.97,.77,5.74-.26,3.4-1.99,8.66-5.06,11.06-6.46,.72-.42,1.17-1.17,1.21-2.02l-.09-4.63c-1.96,1.13-10.93,6.33-13.94,8.15-.73,.44-1.63,.44-2.35,0l-10.52-6.35h0Z',
  'M76.7,32.93v7.61c0,.86-.35,1.68-.96,2.27-4.23,4.04-24.62,15.69-28.46,17.87-.39,.22-.86,.22-1.25,0l-11.45-6.61,.03-13.83c-.02-.54,.27-1.05,.75-1.3l4.42-2.37s6.02,4.44,9.03,3.05c3.14-1.6,11.97-7.3,14.86-9.3,.63-.44,1-1.16,1-1.94v-3.76s7.1,3.71,10.36,5.47c1.04,.56,1.68,1.65,1.68,2.84h-.01Z',
  'M46.66,61.11c-.26,0-.52-.07-.76-.21l-11.58-6.68,.03-13.98c-.02-.64,.32-1.23,.88-1.53l4.56-2.44,.13,.1c.06,.04,5.93,4.33,8.77,3.02,3.11-1.58,12.01-7.33,14.82-9.28,.56-.39,.89-1.03,.89-1.72v-4.19l.38,.2c.07,.04,7.14,3.74,10.36,5.48,1.12,.6,1.81,1.78,1.81,3.07v7.61c0,.92-.38,1.82-1.04,2.45-4.26,4.07-24.5,15.63-28.51,17.91-.23,.13-.49,.2-.74,.2h0Zm-11.82-7.2l11.32,6.53c.31,.18,.68,.18,.99,0,4.01-2.27,24.19-13.8,28.41-17.83,.56-.54,.89-1.3,.89-2.08v-7.61c0-1.1-.59-2.1-1.55-2.61-2.79-1.51-8.46-4.48-9.98-5.27v3.34c0,.86-.42,1.66-1.11,2.15-2.73,1.89-11.62,7.66-14.89,9.32-2.9,1.34-8.23-2.31-9.17-2.98l-4.28,2.29c-.39,.21-.62,.61-.61,1.06l-.03,13.69h0Z',
  'M14.07,22.58l-6.84,3.89c-.71,.42-.97,1.34-.99,2.18l-.23,10.04-3.75-2.4c-1.24-.76-2-2.14-2-3.64v-9.25c0-1.26,.65-2.43,1.7-3.04l10.63-6.09-1.12,6.07c-.08,.5,.17,1,.62,1.23l1.98,1h0Z',
  'M6.26,39.15l-4.14-2.64c-1.3-.8-2.12-2.28-2.12-3.86v-9.25c0-1.35,.7-2.61,1.83-3.27l11.11-6.37-1.22,6.62c-.06,.39,.13,.77,.49,.96l2.41,1.22-7.26,4.13c-.74,.44-.85,1.52-.86,1.96l-.25,10.5h.01ZM12.24,14.77L2.1,20.58c-.97,.57-1.58,1.65-1.58,2.82v9.25c0,1.4,.72,2.71,1.88,3.42l3.37,2.15,.22-9.58c.03-1.11,.43-1.99,1.11-2.4l6.42-3.66-1.55-.79c-.56-.29-.86-.89-.76-1.51l1.02-5.52h.01Z',
  'M62.65,18.4l-.08,7.94c-.02,.62-.87,1.36-1.37,1.67l-12.03,7.78c-4.1,2.78-9.85-2.49-9.85-2.49,0,0,.55-3.33-1.09-5-1.65-1.67-12.2-7.24-15.13-8.77-.47-.25-1.03-.26-1.51-.03-1.01,.49-2.94,1.54-3.3,1.8,0,0-1.03-.53-1.84-.94-.4-.21-.62-.65-.55-1.1l1.27-7.7c0-.65,.33-1.25,.85-1.56L33.34,.9c.5-.3,1.1-.3,1.59,0l26.43,15.42c.91,.53,1.32,1.02,1.28,2.09h.01Z',
  'M46.44,36.87c-3.56,0-7.11-3.21-7.29-3.38l-.1-.09,.02-.14s.51-3.23-1.02-4.78c-1.28-1.3-8.62-5.36-15.06-8.72-.4-.21-.87-.22-1.27-.02-1.02,.49-2.93,1.54-3.26,1.78l-.13,.09-1.98-1.01c-.5-.26-.78-.81-.69-1.37l1.27-7.7c0-.7,.37-1.39,.98-1.74L33.2,.68c.58-.35,1.28-.35,1.86,0l26.43,15.42c.93,.54,1.45,1.09,1.41,2.32l-.07,7.94c-.03,.81-1.09,1.64-1.49,1.89l-12.03,7.78c-.91,.62-1.89,.86-2.87,.86v-.02Zm-6.84-3.67c.78,.67,5.83,4.82,9.43,2.38l12.04-7.78c.5-.31,1.24-.98,1.25-1.46l.07-7.94c.03-.89-.24-1.32-1.16-1.85L34.8,1.12c-.42-.25-.92-.25-1.33,0l-15.31,9.1c-.45,.26-.73,.78-.73,1.34l-1.27,7.74c-.05,.34,.11,.67,.41,.83l1.71,.87c.58-.36,2.3-1.3,3.2-1.73,.56-.27,1.19-.26,1.74,.03,3.14,1.64,13.52,7.13,15.19,8.82,1.54,1.56,1.27,4.4,1.19,5.08Z',
];

const Preloader: React.FC = () => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    const timer = window.setTimeout(() => {
      setVisible(false);
      document.body.style.overflow = '';
    }, 4100);
    return () => {
      window.clearTimeout(timer);
      document.body.style.overflow = '';
    };
  }, []);

  if (!visible) return null;

  return (
    <div className="ml-preloader" aria-hidden="true">
      <style>{`
        .ml-preloader {
          position: fixed;
          inset: 0;
          background: #ffffff;
          z-index: 9999;
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;
          animation: mlExit 0.7s cubic-bezier(0.76, 0, 0.24, 1) 3.3s forwards;
        }
        .ml-preloader svg {
          width: 150px;
          height: auto;
          position: relative;
          z-index: 1;
        }
        @media (max-width: 640px) {
          .ml-preloader svg { width: 118px; }
        }
        .ml-path {
          fill: #4452e3;
          fill-opacity: 0;
          stroke: #4452e3;
          stroke-width: 1.01px;
          stroke-miterlimit: 10;
          stroke-dasharray: 1;
          stroke-dashoffset: 1;
          animation: mlDraw 2.3s ease forwards, mlFill 0.5s ease 2.2s forwards;
        }
        .ml-panel {
          position: absolute;
          inset: 0;
          background: #4452e3;
          transform: translateY(100%);
          z-index: 2;
          animation: mlPanelUp 0.6s cubic-bezier(0.76, 0, 0.24, 1) 2.85s forwards;
        }
        @keyframes mlDraw { to { stroke-dashoffset: 0; } }
        @keyframes mlFill { to { fill-opacity: 1; } }
        @keyframes mlPanelUp { to { transform: translateY(0); } }
        @keyframes mlExit { to { transform: translateY(-100%); } }
        @media (prefers-reduced-motion: reduce) {
          .ml-path { animation: none; stroke-dashoffset: 0; fill-opacity: 1; }
          .ml-panel { display: none; }
          .ml-preloader { animation: mlExit 0.4s ease 0.8s forwards; }
        }
      `}</style>

      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 76.95 70.8">
        {LOGO_PATHS.map((d, i) => (
          <path key={i} className="ml-path" d={d} pathLength={1} />
        ))}
      </svg>

      <div className="ml-panel" />
    </div>
  );
};

export default Preloader;
